
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="data"
      class="elevation-0"
      :search="search"
      mobile-breakpoint="1"
    >
      <template v-slot:top>
        <v-row align="center" justify="space-between" >
          <v-col cols="12" md="6" class="pt-0">
            <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Encontrar" color="secondary"></v-text-field>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.id="{ item }">
        <v-tooltip top color='black'>
          <template v-slot:activator='{on}'>
            <v-btn v-on="on" icon small color="secondary" @click="itemDetails(item)">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          Mais sobre este item
        </v-tooltip>
      </template>

      <template v-slot:item.form="{ item }">
        <span class="secondary--text font-weight-bold" @click="formDetails(item)" style="cursor: pointer;">
          {{item.form.slice(0,30)}}{{item.form.length>30? '...':''}}
        </span>
        <v-btn small icon color="secondary" class=" no-text-transform" @click="formDetails(item)">
          <!-- {{item.form.slice(0,30)}}{{item.form.length>30? '...':''}} -->
          <v-icon size='18'>mdi-open-in-new</v-icon>
        </v-btn>

      </template>

      <template v-slot:item.dep_id="{ item }">
        <span class="secondary--text font-weight-bold" @click="deptDetails(item)" style="cursor: pointer;">
          {{item.dep_name.slice(0,30)}}{{item.dep_name.length>30? '...':''}}
        </span>
        <v-btn icon small color="secondary" @click="deptDetails(item)">
          <v-icon size="18">mdi-open-in-new</v-icon>
        </v-btn>
      </template>

    </v-data-table>

    <dialog-department @close='handleCloseDepartment' v-if="dialog_department" :dept_id='department_id' :department="department"></dialog-department>
    <dialog-form @close='handleCloseForm' v-if="dialog_form" :form_id='form_id' :form="form"></dialog-form>
    <dialog-item @close='handleCloseItem' v-if="dialog_item" :item_id='item_id' :item='item'></dialog-item>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DetailsMixin from './_details_mixin'

export default {
  name: 'ItemsTable',
  components: {
    DialogItem: ()=> import('./dialogs/DialogItem.vue'),
    DialogForm: ()=> import('./dialogs/DialogForm.vue'),
    DialogDepartment: ()=> import('./dialogs/DialogDepartment.vue'),
  },
  props: {
    data: {
      type: Array,
      default: ()=> []
    },
  },
  mixins: [DetailsMixin],
  data() {
    return {
      dialog: false,
      search: null,
      headers: [
        // {text: '', value: 'id'},
        {text: 'Mais', value: 'id', width:'10%'},
        {text: 'Título', value: 'title', width:'18%'},
        {text: 'Sentença', value: 'sentence', width:'22%'},
        {text: 'Falhas', value: 'count', width:'10%'},
        {text: 'Formulário', value: 'form', width:'22%'},
        {text: 'Dept.', value: 'dep_id', width:'18%'},
      ],

    }
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>